import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { DocumentRefService } from '../helpers/document-ref.service';
import { HttpClientSkippingInterceptorsService } from '../http-client-skipping-interceptors.service';

@Injectable()
export class ThemeService {
    colors: string[] = [];

    constructor(
        private documentRefService: DocumentRefService,
        private http: HttpClientSkippingInterceptorsService
    ) {
        this.colors = [
            'theme-accent-50',
            'theme-accent-100',
            'theme-accent-200',
            'theme-accent-300',
            'theme-accent-400',
            'theme-accent-500',
            'theme-accent-600',
            'theme-accent-700',
            'theme-accent-800',
            'theme-accent-900',
            'theme-accent-A100',
            'theme-accent-A200',
            'theme-accent-A400',
            'theme-accent-A700',
        ];
    }

    async updateTheme(brand: string): Promise<void> {
        const path = `/assets/styles/themes/${brand}.theme.scss`;

        try {
            await lastValueFrom(this.http.head(path));
            this.colors.forEach((color) => {
                this.documentRefService.setDocumentProperty(
                    `--app-${color}`,
                    `var(--${brand}-${color})`
                );
            });
        } catch {
            return;
        }
    }
}
